// Префикс для названия базы данных
export const SESSION_PREFIX = 'session-';

export enum ObjectStoreNames {
    Recording = 'recording',
    Metadata = 'metadata',
}
